import classNames from 'classnames';
import React, { ReactNode } from 'react';

import css from './FormErrorMessage.module.scss';

interface Props {
  children?: ReactNode;
}

const FormErrorMessage = ({ children }: Props) => {
  const classes = classNames(css.FormErrorMessage);

  return <div className={classes}>{children}</div>;
};

export default FormErrorMessage;
